export default __webpack_public_path__ + "static/i_1-c94e172909cfec599b25e0f9a394a78b.png";